<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li>
              <router-link to="/accounting/home" class="active">{{
                $t("accounting")
              }}</router-link>
            </li>
            <li>-</li>
            <li>
              <router-link to="/accounting/JournalEntry" class="active">{{
                $t("JL")
              }}</router-link>
            </li>
            <li>-</li>
            <li>
              <router-link to="/accounting/JournalEntry/CreateJournalEntry" class="active">{{ $t("add") }} {{ $t("JL")
                }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <h3>{{ $t("add") }} {{ $t("JL") }} - {{ id }}</h3>
          </div>
          <div class="head2">
            <button @click="submit" :disabled="disabled">{{ $t("save") }}</button>
          </div>
        </div>
        <div class="body">
          <div class="body1" style="display: flex">
            <div class="group">
              <label for="basic-url" class="form-label">{{ $t("type") }} {{ $t("journal") }}
                <span class="error-feedback" v-if="v$.jltype.$error">{{
                  "*"
                }}</span>
              </label>
              <div>
                <input type="text" v-model="jltype" />
              </div>
              <label for="basic-url" class="form-label">{{ $t("date") }}
                <span class="error-feedback" v-if="v$.date.$error">{{
                  "*"
                }}</span>
              </label>
              <div>
                <input type="date" v-model="date" />
              </div>
            </div>
            <div class="group">
              <label for="basic-url" class="form-label">{{ $t("from") }} {{ $t("fastjl") }}
              </label>
              <div>
                <select></select>
              </div>
              <label for="basic-url" class="form-label">{{ $t("ccenter") }} {{ $t("parent") }}
              </label>
              <div>
                <select v-model="parent">
                  <option v-for="x in level1" :key="x" :value="x.actnum">
                    {{ x.namear }}
                  </option>
                </select>
              </div>
  
              <label for="basic-url" class="form-label">{{ $t("ccenter") }} {{ $t("secondary") }}
              </label>
              <div>
                <select v-model="parent2">
                  <option v-for="x in level2" :key="x" :value="x.actnum">
                    {{ x.namear }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <hr />
          <h6>{{ $t("details") }} {{ $t("JL") }}</h6>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th scope="col">{{ $t("dpt") }}</th>
                <th scope="col">{{ $t("crd") }}</th>
                <th scope="col">{{ $t("Account") }}</th>
                <td scope="col">{{ $t("ccenter") }}</td>
                <td scope="col">{{ $t("details") }}</td>
                <td scope="col">{{ $t("Cancel") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, id) of data" :key="value">
                <td>{{ id + 1 }}</td>
                <td scope="row" style="width: 10%">
                  <input class="form-control form-control-sm" type="number" @change="cal" v-model="value.dpt" />
                </td>
                <td scope="row" style="width: 10%">
                  <input class="form-control form-control-sm" type="number" @change="cal" v-model="value.crd" />
                </td>
                <td scope="row" style="width: 20%">
                  <v-select :options="data1" label="namear" v-model="value.act">
                    <template #option="option">
                      <span>{{ option.namear }}</span>
                    </template>
                  </v-select>
                  <button @click="showAccountModal(id)" class="btn-add-account">
                    {{ $t("add") }} {{ $t("Account") }}
                  </button>
                </td>
                <td>
                  <select v-model="value.costcenter">
                    <option v-for="x in level3" :key="x" :value="x">
                      {{ x.namear }}
                    </option>
                  </select>
                </td>
                <td scope="row" style="width: 30%"><input type="text" v-model="value.details" style="width: 100%;"></td>
                <td>
                  <a href="#" @click.prevent="del(value)"><i class="bi bi-x-circle-fill"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
          <button @click="add" style="padding: 0.25%">
            {{ $t("add") }} <i class="bi bi-plus"></i>
          </button>
          <hr />
          <div class="body1" style="display: flex">
            <div class="group">
              <label for="basic-url" class="form-label">{{ $t("total") }} {{ $t("dpt") }}
              </label>
              <div>
                <input type="number" v-model="totaldpt" />
              </div>
              <label for="basic-url" class="form-label">{{ $t("total") }} {{ $t("crd") }}
              </label>
              <div>
                <input type="number" v-model="totalcrd" />
              </div>
            </div>
            <div class="group">
              <label for="basic-url" class="form-label">{{
                $t("description")
              }}</label>
              <div class="mb-3 input-group">
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="description"></textarea>
              </div>
            </div>
          </div>
          <br />
          <div class="mb-2 row">
            <label class="col-sm-2 col-form-label-sm">
              <i class="bi bi-pin-angle-fill"></i> {{ $t("add") }}
              {{ $t("attachments") }}
            </label>
            <div class="col-sm-8">
              <div>
                <div>
                  <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
                </div>
                <br />
                <table class="table" style="width: 25%">
                  <thead>
                    <tr>
                      <th>{{ $t("name") }}</th>
                      <th>{{ $t("cancel") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(file, key) in files" :key="file">
                      <td>{{ file.name }}</td>
                      <td>
                        <a href="#" class="remove-file" v-on:click="removeFile(key)"><i
                            class="bi bi-x-circle-fill"></i></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
  
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Modal for Adding New Account -->
      <div class="modal" v-if="showModal">
        <div class="modal-content">
          <div class="modal-header">
            <h4>{{ $t("add") }} {{ $t("Account") }}</h4>
            <button @click="closeModal" class="close">×</button>
          </div>
          <div class="modal-body">
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("Account") }} {{ $t("main") }}</label>
              <div class="col-sm-4">
                <v-select :options="data1" label="namear" v-model="newAccount.filter">
                  <template #option="option">
                    <span>{{ option.namear }}</span>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="mb-2 row" v-if="newAccount.typeaccountselect">
              <label class="col-sm-2 col-form-label-sm">{{ $t("nature") }} {{ $t("Account") }}</label>
              <div class="col-sm-4">
                <select class="form-select" v-model="newAccount.typeact">
                  <option value="debit">{{ $t("debit") }}</option>
                  <option value="credit">{{ $t("credit") }}</option>
                </select>
              </div>
            </div>
            <div class="mb-2 row" v-if="!newAccount.typeaccountselect">
              <label class="col-sm-2 col-form-label-sm">{{ $t("nature") }} {{ $t("Account") }}</label>
              <div class="col-sm-4">
                <select class="form-select" v-model="newAccount.typeact" disabled>
                  <option value="debit">{{ $t("debit") }}</option>
                  <option value="credit">{{ $t("credit") }}</option>
                </select>
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("accepte") }} {{ $t("transaction") }}</label>
              <div class="col-sm-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="newAccount.sup"
                />
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("name") }} {{ $t("ar") }}</label>
              <div class="col-sm-4">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="newAccount.namear"
                  ref="namearInput"
                />
                <span class="error-feedback" v-if="vAccount$.namear.$error">{{ $t("required") }}</span>
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("name") }} {{ $t("en") }}</label>
              <div class="col-sm-4">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="newAccount.nameen"
                />
                <span class="error-feedback" v-if="vAccount$.nameen.$error">{{ $t("required") }}</span>
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("code") }} {{ $t("Account") }}</label>
              <div class="col-sm-4">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="newAccount.accountcode"
                />
                <span class="error-feedback" v-if="vAccount$.accountcode.$error">{{ $t("required") }}</span>
              </div>
            </div>
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">{{ $t("description") }}</label>
              <div class="col-sm-4">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="newAccount.description"
                ></textarea>
                <span class="error-feedback" v-if="vAccount$.description.$error">{{ $t("required") }}</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="saveAccount" class="btn btn-primary" :disabled="isSaving">
              {{ isSaving ? $t("saving") : $t("save") }}
            </button>
            <button @click="closeModal" class="btn btn-secondary" :disabled="isSaving">{{ $t("cancel") }}</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import store from "@/store";
  import { reactive } from "vue";
  import useValidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";
  import axios from "axios";
  import vSelect from "vue-select";
  
  export default {
    components: {
      vSelect,
    },
    props: ["css"],
    setup() {
      const newAccount = reactive({
        filter: "",
        itemnum: "",
        namear: "",
        nameen: "",
        accountcode: "1",
        description: "",
        typeaccount: "",
        typeact: "",
        sup: false,
        parent: "",
        level: "",
        typeaccountselect: false,
      });
  
      const accountRules = {
        namear: { required },
        nameen: { required },
        accountcode: { required },
        description: { required },
      };
  
      const vAccount$ = useValidate(accountRules, newAccount);
  
      return { newAccount, vAccount$ };
    },
    data() {
      return {
        disabled: false,
        v$: useValidate(),
        data: [
          {
            dpt: 0,
            crd: 0,
            actnum: 0,
            namear: "",
            nameen: "",
            details: "",
            costcenter: { actnum: "", namear: "" },
          },
          {
            dpt: 0,
            crd: 0,
            actnum: 0,
            namear: "",
            nameen: "",
            details: "",
            costcenter: { actnum: "", namear: "" },
          },
        ],
        data1: [],
        date: "",
        branches: [],
        allprojects: [],
        alltasks: [],
        project: "",
        task: "",
        branch: "",
        description: "",
        totaldpt: 0,
        totalcrd: 0,
        addto: "",
        url: null,
        files: [],
        fileURL: [],
        id: "",
        type: "",
        jltype: "",
        level1: [],
        level2: [],
        level3: [],
        parent: "",
        parent2: "",
        err: false,
        showModal: false,
        isSaving: false,
        selectedRowIndex: null,
      };
    },
    validations() {
      return {
        date: { required },
        description: { required },
        jltype: { required },
      };
    },
    async mounted() {
      const result = await axios.get("/data/getaccounttrue");
      const result2 = await axios.get("/data/getcostcenter");
      const result4 = await axios.get("/data/allcustomer");
      const result6 = await axios.get("/data/JournalEntryID");
      if (result.status == 200) {
        this.data1 = result.data.data;
        this.data2 = result.data.data;
        this.branches = result2.data.data.map(item => ({
          ...item,
          actnum: String(item.actnum),
        }));
        this.allprojects = result4.data.data;
        this.level1 = this.branches.filter((x) => x.level == 1);
        this.id = Number(result6.data.data[0].count) + Number(1);
      }
    },
    methods: {
      back() {
        this.$root.$router.push({
          path: "/accounting/JournalEntry",
        });
      },
      cal() {
        this.totaldpt = Number(
          this.data.reduce((acc, array) => acc + Number(array.dpt), 0)
        ).toFixed(2);
        this.totalcrd = Number(
          this.data.reduce((acc, array) => acc + Number(array.crd), 0)
        ).toFixed(2);
      },
      async del(value) {
        const indexOfObject = this.data.findIndex((object) => {
          return (
            object.namear === value.namear &&
            object.nameen === value.nameen &&
            object.details === value.details
          );
        });
        this.data.splice(indexOfObject, 1);
      },
      add() {
        this.data.push({
          dpt: 0,
          crd: 0,
          act: "",
          actnum: "",
          namear: "",
          nameen: "",
          details: "",
          totaldpt: 0,
          totalcrd: 0,
          costcenter: { actnum: "", namear: "" },
        });
      },
      async submit() {
        await this.v$.$validate();
        console.log(this.v$.$error);
        if (!this.v$.$error) {
          for (let i = 0; i < this.data.length; i++) {
            const element = this.data[i];
            if (!element.act) {
              this.err = true;
              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
              });
              Toast.fire({
                icon: "error",
                title: "برجاء مراجعة القيد",
              });
              break;
            } else {
              this.err = false;
            }
          }
          if (this.totalcrd == this.totaldpt && this.totalcrd != 0 && this.err == false) {
            this.disabled = true;
            for (var i = 0; i < this.files.length; i++) {
              let file = this.files[i];
              let formData = new FormData();
              let name = this.files[i].name.split(".");
              let newname = this.id + "_" + i + "." + name[name.length - 1];
              this.fileURL.push({ name: newname });
              formData.append("file", file, newname);
              await axios.patch(`/uploads/${i}`, formData);
            }
            const result = await axios.post("/data/createnewjournalenty", {
              username: store.state.randp.username,
              type: this.jltype,
              trandate: this.date,
              branch: this.branch,
              description: this.description,
              details: JSON.stringify(this.data),
              project: this.project,
              task: this.task,
              totaldpt: this.totaldpt,
              totalcrd: this.totalcrd,
              fileurl: JSON.stringify(this.fileURL),
            });
            if (result.status == 200) {
              this.redirectTo({ val: "JournalEntry" });
              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
              });
              Toast.fire({
                icon: "success",
                title: "Data Entry successfully",
              });
            } else if (result.status == 401) {
              alert("Account Already Created Before");
            }
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "error",
              title: "برجاء مراجعة القيد",
            });
          }
        } else {
          const errors = this.v$.$errors
            .map(error => `${error.$property}: ${error.$message || 'Required'}`)
            .join('\n');
          if (errors) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "error",
              title: "Validation Errors",
              text: errors,
            });
          }
        }
      },
      addFiles() {
        this.$refs.files.click();
      },
      submitFiles() {
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          let formData = new FormData();
          let name = this.files[i].name.split(".");
          let newname = i + "." + name[name.length - 1];
          this.fileURL.push({ name: i + "." + newname });
          formData.append("file", file, newname);
          axios.patch(`/uploads/${i}`, formData);
        }
      },
      handleFilesUpload() {
        let uploadedFiles = this.$refs.files.files;
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push(uploadedFiles[i]);
        }
      },
      removeFile(key) {
        this.files.splice(key, 1);
      },
      showAccountModal(rowIndex) {
        this.selectedRowIndex = rowIndex;
        this.showModal = true;
        this.resetNewAccount();
        this.$nextTick(() => {
          this.$refs.namearInput.focus();
        });
      },
      closeModal() {
        this.showModal = false;
        this.selectedRowIndex = null;
        this.resetNewAccount();
      },
      resetNewAccount() {
        Object.assign(this.newAccount, {
          filter: "",
          itemnum: "",
          namear: "",
          nameen: "",
          accountcode: "1",
          description: "",
          typeaccount: "",
          typeact: "",
          sup: false,
          parent: "",
          level: "",
          typeaccountselect: false,
        });
        this.isSaving = false;
        this.vAccount$.$reset();
      },
      async saveAccount() {
        await this.vAccount$.$validate();
        if (!this.vAccount$.$error) {
          this.isSaving = true;
          try {
            const result = await axios.post("/data/accountingmanual", {
              username: store.state.randp.username,
              namear: this.newAccount.namear,
              nameen: this.newAccount.nameen,
              actnum: String(this.newAccount.accountcode),
              parent: this.newAccount.parent,
              description: this.newAccount.description,
              typeaccount: this.newAccount.typeaccount,
              typeact: this.newAccount.typeact,
              sup: this.newAccount.sup,
              level: this.newAccount.level,
            });
            if (result.status == 200) {
              const newAccountData = {
                namear: this.newAccount.namear,
                nameen: this.newAccount.nameen,
                actnum: String(this.newAccount.accountcode),
                parent: this.newAccount.parent,
                description: this.newAccount.description,
                typeaccount: this.newAccount.typeaccount,
                typeact: this.newAccount.typeact,
                sup: this.newAccount.sup,
                level: this.newAccount.level,
              };
              this.data1.push(newAccountData);
              if (this.selectedRowIndex !== null) {
                this.data[this.selectedRowIndex].act = newAccountData;
              }
              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              Toast.fire({
                icon: "success",
                title: "Account Created Successfully",
              });
              this.closeModal();
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Account Creation Failed",
              });
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Account Already Exists or Invalid Data",
            });
          } finally {
            this.isSaving = false;
          }
        }
      },
      ...mapActions(["redirectTo"]),
    },
    watch: {
      filter() {
        this.data1 = this.data2.filter((x) =>
          x.nameact.includes(this.filter.toLowerCase())
        );
      },
      parent() {
        this.level2 = this.branches.filter(
          (x) =>
            x.actnum &&
            String(x.actnum).startsWith(String(this.parent)) &&
            x.actnum != this.parent &&
            x.sup == "false"
        );
        this.level3 = this.branches.filter(
          (x) =>
            x.actnum &&
            String(x.actnum).startsWith(String(this.parent)) &&
            x.actnum != this.parent &&
            x.sup == "true"
        );
      },
      parent2() {
        this.level3 = this.branches.filter(
          (x) =>
            x.actnum &&
            String(x.actnum).startsWith(String(this.parent2)) &&
            x.actnum != this.parent2 &&
            x.sup == "true"
        );
      },
      "newAccount.filter"() {
        if (this.newAccount.filter) {
          this.newAccount.itemnum = this.newAccount.filter.actnum;
          this.newAccount.level = Number(this.newAccount.filter.level) + 1;
        }
      },
      "newAccount.itemnum"() {
        if (this.newAccount.itemnum == "main") {
          this.newAccount.typeaccountselect = true;
          const mainAccounts = this.data1.filter((x) => String(x.actnum).length == 1);
          const last = mainAccounts[mainAccounts.length - 1];
          const lastnu = last ? last.actnum : "0";
          this.newAccount.accountcode = String(Number(lastnu) + 1);
        } else {
          const filteredAccounts = this.data1.filter((x) =>
            String(x.actnum).startsWith(String(this.newAccount.itemnum).toLowerCase())
          );
          this.newAccount.typeaccountselect = false;
          if (filteredAccounts.length > 0) {
            this.newAccount.typeaccount = filteredAccounts[0].typeaccount;
            this.newAccount.typeact = filteredAccounts[0].typeact;
            this.newAccount.parent = filteredAccounts[0].actnum;
            if (filteredAccounts.length > 1) {
              const last = filteredAccounts.slice(1);
              const lastarr = last[last.length - 1];
              const lastnu = lastarr.actnum;
              this.newAccount.accountcode = String(Number(lastnu) + 1);
            } else {
              const lastnu = filteredAccounts[0].actnum;
              this.newAccount.accountcode = lastnu + "01";
            }
          }
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .page {
    padding: 0.5%;
  }
  
  .main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 5px;
    border: ridge 0.5px;
  }
  
  .main .body {
    padding: 1%;
  }
  
  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }
  
  .head1 {
    width: 70%;
  }
  
  .head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }
  
  .head2 {
    width: 30%;
    text-align: center;
  }
  
  button {
    margin: 0.5%;
    padding: 2%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
  }
  
  .group {
    padding: 1%;
    width: 50%;
  }
  
  .group input {
    width: 80%;
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }
  
  select {
    width: 80%;
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }
  
  .table {
    margin-top: 1%;
  }
  
  table thead tr {
    border-radius: 5px;
    background-color: #eee;
  }
  
  .btn-add-account {
    margin-top: 0.5%;
    padding: 0.5%;
    font-size: 0.8rem;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 50%;
    max-height: 80%;
    overflow-y: auto;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }
  
  .modal-header .close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }
  
  .modal-body {
    padding: 20px 0;
  }
  
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #ddd;
    padding-top: 10px;
  }
  
  .modal-footer button {
    margin-left: 10px;
    padding: 8px 16px;
    border-radius: 5px;
  }
  
  .modal-footer .btn-primary:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }
  
  .error-feedback {
    color: red;
    margin-left: 5px;
    font-size: 0.8rem;
  }
  </style>